<template>
  <div class="songs-list-wrap">
    <div class="songs-list-controls">
      <div class="arrow prev" @click="rotateDrum(0)"/>
      <div class="info">
        <span>Lied</span>
        <br>{{ controlCounterCurrent }} von {{ controlCounterAll }}
      </div>
      <div class="arrow next" @click="rotateDrum(1)"/>
    </div>
    <div class="songs-list" ref="list">
      <router-link class="logo" to="/grusswort">
        <img src="../assets/logo.png" alt="">
      </router-link>
      <svg class="list" viewBox="0 0 1000 1000">
        <defs>
          <radialGradient id="centerGradient">
            <stop offset="20%" stop-color="white"/>
            <stop offset="95%" stop-color="#eaeaea"/>
          </radialGradient>
          <radialGradient id="raysGradient">
            <stop offset="50%" stop-color="#eaeaea" stop-opacity="0"/>
            <stop offset="90%" stop-color="#eaeaea" stop-opacity="1"/>
          </radialGradient>
        </defs>
        <circle class="gradient" fill="url(#centerGradient)" cx="500" cy="500" r="450"/>
        <g class="rays-container">
          <image href="../assets/rays.svg"/>
          <rect fill="url(#raysGradient)" class="rays-gradient" x="0" y="0" width="1000" height="1000"/>
        </g>
        <circle
            class="circle-small"
            :r="circleRadius - circleStrokeWidth / 1.5"
            cx="500" cy="500"/>
        <circle
            class="circle"
            :r="circleRadius"
            :stroke-width="circleStrokeWidth"
            cx="500" cy="500"/>
        <g transform="translate(500 500)">
          <g ref="drum" class="drumRotateTransition" :transform="`rotate(${drumAngle})`"
             :style="`transform: rotate(${drumAngle}deg)`"
          >
            <g v-for="(song, index) in songsList" :key="'song-' + song.deeplink + index">
              <template v-if="mobileView && isMobileHidden(index)">
              </template>
              <template v-else>
                <g class="kanon" :transform="getRotateSection(index)" v-if="song.typ === 'kanon'">
                  <circle
                      class="circle"
                      :r="circleRadius"
                      :stroke-width="circleStrokeWidth"
                      :stroke-dasharray="`${(754 / songsCount - 2)} 2000`"
                      stroke-dashoffset="-11"
                      cx="0" cy="0"/>
                </g>
                <line class="line"
                      :x1="circleRadius - circleStrokeWidth / 2"
                      :x2="circleRadius + circleStrokeWidth / 2"
                      y1="0" y2="0"
                      :transform="getRotateLine(index)"
                />
                <g :transform="getRotate(index)" :class="isReverted(index) ? 'getRevert' : ''">
                  <text
                      @click="linkTo(song.deeplink)"
                      class="song-text"
                      x="0" y="0"
                      v-tooltip="getTooltipContent(song)"
                  >
                    {{ song.title }}
                  </text>
                  <text
                      text-anchor="end"
                      @click="linkTo(song.deeplink)"
                      class="song-text reverted"
                      x="0" y="10"
                      transform="scale(-1)"
                      v-tooltip="getTooltipContent(song)"
                  >
                    {{ song.title }}
                  </text>
                </g>
              </template>
            </g>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  data() {
    return {
      touchStep: 20,
      circle: 360,
      mobileFactor: 3,
      circleStrokeWidth: 25,
      circleRadius: 120,
      drumStep: 1,
      drumAngle: 0,
      mobileView: false,
      mobileBreakpointWidth: 720,
      mobileBreakpointHeight: 480,
    }
  },
  computed: {
    ...mapGetters(['songs']),
    ...mapActions(['setTooltipText']),
    controlCounterCurrent() {
      return this.drumStep
    },
    controlCounterAll() {
      return this.mobileView ? this.songsCount / this.mobileFactor : this.songsCount
    },
    songsCount() {
      return this.songsList.length
    },
    songsList() {

      if (this.mobileView) {
        return [...this.songs, ...this.songs, ...this.songs];
      } else {
        return this.songs;
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.changeSVGParams);
    this.changeSVGParams();

    let start = 0;

    this.$refs.list.addEventListener('touchstart', e => {
      start = e.touches[0].clientY;
    });

    this.$refs.list.addEventListener('touchmove', e => {
      if (start - e.touches[0].clientY > this.touchStep) {
        start = e.touches[0].clientY;
        this.rotateDrum(false);
      } else if (start - e.touches[0].clientY < this.touchStep * -1) {
        start = e.touches[0].clientY;
        this.rotateDrum(true);
      }
    });
  },
  created() {
    this.$store.dispatch('fetchSongs');
  },
  methods: {
    changeSVGParams() {
      if (window.innerWidth >= this.mobileBreakpointWidth || window.innerHeight <= this.mobileBreakpointHeight) {
        this.circleStrokeWidth = 25; // Desktop circle stroke width
        this.mobileView = false;
      } else {
        this.circleStrokeWidth = 10; // Mobile circle stroke width
        this.mobileView = true;
      }
    },
    getTooltipContent(song) {
      let list = '';

      Object.keys(song.songs).forEach(key => {
        let name = '<br>- ';
        switch (key) {
          case 'classic':
            name += 'klassisch';
            break;
          case 'chorus':
            name += 'Chor';
            break;
          case 'modern':
            name += 'modern';
            break;
          case 'brass':
            name += 'Bläser';
            break;
          default:
            name = '';
        }
        list += name;
      });

      return `Hier finden Sie Hintergrundinformationen zum Lied, den Liedtext und können sich das Stück in folgenden Versionen anhören: ${list}`;
    },
    linkTo(index) {
      this.$router.push({
        path: 'song/' + index,
      });
    },
    rotateDrum(clockwise) {
      if (clockwise) {
        if (this.drumStep === this.controlCounterAll) {
          this.drumStep = 1;
        } else {
          this.drumStep += 1;
        }
        this.getRotateDrum(1);
      } else {
        if (this.drumStep === 1) {
          this.drumStep = this.controlCounterAll;
        } else {
          this.drumStep -= 1;
        }
        this.getRotateDrum(0);
      }

    },
    getRotate(index) {
      const angle = this.circle / this.songsCount * index;

      return `rotate(${angle}) translate(${this.circleRadius + this.circleStrokeWidth} 0)`
    },
    getRotateSection(index) {
      const step = this.circle / this.songsCount;
      let angle = step * index - step;

      if (this.mobileView) {
        angle = angle - step / 1.5
      }

      return `rotate(${angle})`
    },
    getRotateLine(index) {
      const angle = this.circle / this.songsCount * index + this.circle / this.songsCount / 3;

      return `rotate(${angle})`
    },
    getRotateDrum(clockwise) {
      const step = this.circle / this.songsCount;

      if (clockwise) {
        this.drumAngle += step;
      } else {
        this.drumAngle -= step;
      }
    },
    isReverted(index) {
      const angle = this.circle / this.songsCount * index;
      const itemRotate = angle + this.drumAngle;

      return itemRotate % 360 >= 90 && itemRotate % 360 < 270
    },
    isMobileHidden(index) {
      const angle = this.circle / this.songsCount * index;
      const itemRotate = angle + this.drumAngle;

      return itemRotate % 360 >= 70 && itemRotate % 360 < 310
    }
  }
}
</script>